import axios from 'axios'
import { Message } from 'element-ui'
import { menuCache } from '@/utils/menuCache'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 10000
})

function redirectToLogin() {
  window.location.replace(`${window.location.origin}${window.location.pathname}#/login`)
}

service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('Auth-Token')
    if (token) {
      config.headers.Authorization = 'Bearer ' + token
    }
    return config
  },
  error => Promise.reject(error)
)

service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200) {
      Message({ message: res.message || '请求失败', type: 'error', duration: 3000 })
      return Promise.reject(new Error(res.message || '请求失败'))
    }
    return res
  },
  error => {
    const requestUrl = `${error.config && error.config.baseURL ? error.config.baseURL : ''}${error.config && error.config.url ? error.config.url : ''}`
    let message = ''

    if (error.response) {
      if (error.response.status === 401) {
        message = '后端接口提示：暂无权限或未登录，无法获取数据'
        localStorage.removeItem('Auth-Token')
        localStorage.removeItem('User-Info')
        menuCache.clear()
        redirectToLogin()
      } else if (error.response.status === 403) {
        message = '后端接口提示：权限不足，拒绝访问'
      } else {
        const data = error.response.data || {}
        const errors = data.errors ? Object.values(data.errors).flat().join('，') : ''
        message = errors || data.message || '请求失败，请检查后端服务'
      }
    } else {
      message = error.code === 'ECONNABORTED'
        ? '请求超时，请稍后重试或检查文件是否过大'
        : `${error.message || '服务器连接失败'}${requestUrl ? `：${requestUrl}` : ''}`
    }

    error.userMessage = message
    Message.error(message)
    return Promise.reject(error)
  }
)

export default service
